/**
 * La raíz del sitio, que reparte según quién llega.
 *
 * Este archivo NO dibuja nada más que el aviso de cuenta suspendida: la portada
 * pública vive en `Portada` —el buscador— y la de quien ya entró en `Inicio`,
 * que se arma según su rol. Acá solo se decide cuál de las dos va.
 *
 * El aviso de suspensión se resuelve ANTES que las dos, y no es un detalle:
 * suspendido no es lo mismo que no haber entrado. Sin él, la persona ve la
 * portada pública con su sesión abierta y no entiende por qué nada de lo suyo
 * aparece.
 */
import { useNavigate } from 'react-router-dom'
import { useSalir } from '../api/hooks'
import { useSesion } from '../auth/sesion'
import { Aviso } from '../componentes/ui'
import { Inicio } from './Inicio'
import { Portada } from './Portada'

export function Home() {
  const { yo, suspendida } = useSesion()
  const salir = useSalir()
  const navigate = useNavigate()

  if (suspendida) {
    return (
      <div className="max-w-xl mx-auto py-8">
        <Aviso tono="error" titulo="Su cuenta está suspendida">
          <p>
            Un administrador retiró el acceso de esta cuenta. Los datos siguen guardados: al
            reactivarla vuelve a encontrar todo como estaba.
          </p>
          <p className="mt-2">
            Escríbanos a{' '}
            <a className="text-marca-600 hover:underline" href="mailto:contacto@compranorte.cl">
              contacto@compranorte.cl
            </a>{' '}
            si cree que es un error, o{' '}
            <button
              type="button"
              className="text-marca-600 hover:underline"
              disabled={salir.isPending}
              onClick={() =>
                salir.mutate(undefined, {
                  onSettled: () => navigate('/entrar', { replace: true }),
                })
              }
            >
              {salir.isPending ? 'cerrando la sesión…' : 'cierre la sesión'}
            </button>
            .
          </p>
        </Aviso>
      </div>
    )
  }

  if (yo) return <Inicio />

  return <Portada />
}
